"use strict";

var _slicedToArray = require("/home/circleci/repo/web_client/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/slicedToArray");

Object.defineProperty(exports, "__esModule", {
  value: true
});

var useGetSet_1 = require("./useGetSet");

var react_1 = require("react");

var useCounter = function useCounter() {
  var initialValue = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0;

  var _useGetSet_1$default = useGetSet_1.default(initialValue),
      _useGetSet_1$default2 = _slicedToArray(_useGetSet_1$default, 2),
      get = _useGetSet_1$default2[0],
      set = _useGetSet_1$default2[1];

  var inc = react_1.useCallback(function () {
    var delta = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 1;
    return set(get() + delta);
  }, []);
  var dec = react_1.useCallback(function () {
    var delta = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 1;
    return inc(-delta);
  }, []);
  var reset = react_1.useCallback(function () {
    var value = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialValue;
    initialValue = value;
    set(value);
  }, []);
  var actions = {
    inc: inc,
    dec: dec,
    get: get,
    set: set,
    reset: reset
  };
  return [get(), actions];
};

exports.default = useCounter;